import React, { useState, useEffect, useContext } from "react";
import brandIcon from "./brandIcon.png";
import info from "./infoColor.png";
import "./Recommender.css";
import {
  CloseOutlined,
  WhatsAppOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { RiWhatsappFill } from "react-icons/ri";
import { HiLink } from "react-icons/hi";
import { MdSms } from "react-icons/md";
import { useSearchParams } from "react-router-dom";
import { onecodeAPI } from "../AppConfig";
import { Modal, Spin } from "antd";
import _ from "lodash";
// import DynamicTextFormatter from "./DynamicTextFormatter";
import "antd/es/spin/style/css";
import { useTranslation } from "react-i18next";
import DynamicTextFormatter from "./DynamicTextFormatter";
import "antd/es/spin/style/css";
import LoanCardMidSection from "./LoanCardMidSection";
import LoanCardModal from "./LoanCardModal";
import ApplyModal from "./ApplyModal.js";
import { FeatureFlagContext } from "../FeatureFlagContext";
import ContentModal from "../lf3/ContentModal";
let lmsRefreshIntervalId = null;
export default function RecommendationCardV2(props) {
  const { partnerDetails, customer, customerDetails, categoryId,isCreditScoreCheck } = props;
  const { oneCode } = useContext(FeatureFlagContext);

  let sessionPartnerDetails = JSON.parse(
    sessionStorage.getItem("partnerDetails")
  );

  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isEligibleModalVisible, setIsEligibleModalVisible] = useState(false);
  const [lf5Url, setLf5Url] = useState("");
  const [responseStatus, setResponseStatus] = useState(null);
  const [lmsInternalStatus, setLmsInternalStatus] = useState(null);
  const [brandNotEligibleReasons, setBrandNotEligibleReasons] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const { t } = useTranslation();
  const [loanCardModalVisible, setLoanCardModalVisible] = useState(false);
  const [emailHandlePopup, setEmailHandlePopup] = useState(false);
  const [handelContentModal, setHandelContentModal] = useState(false);
  const [responsePopContent, setResponsePopContent] = useState({
    heading: "",
    description: "",
    link:""
  });
  const [partnerLink, setPartnerLink] = useState("");

  const showModal = () => {
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleEligiblePopupCancel = () => {
    setIsEligibleModalVisible(false);
  };

  const hideEmailHandlePopup = () => {
    setEmailHandlePopup(false);
  };

  const showLoanCardModal = () => {
    setLoanCardModalVisible(true);
  };

  const handleLoanCardCancel = () => {
    setLoanCardModalVisible(false);
  };

  // useEffect(() => {
  //   if (
  //     (lmsInternalStatus == 2019 ||
  //       lmsInternalStatus == 2020 ||
  //       lmsInternalStatus == 2022) &&
  //     lmsRefreshIntervalId == null
  //   ) {
  //     lmsRefreshIntervalId = setInterval(checkLMSRecommendation, 1000 * 5);
  //   }
  // }, [lmsInternalStatus]);

  const openDetailFile = () => {
    let filePath = partnerDetails?.partnerPdf;
    window.open(filePath, "_blank");
  };

  const checkNavigation = (e) => {
    if (responseStatus == 409) {
      setIsModalVisible(false);
      e.preventDefault();
    }
  };

  // const onLMSBrandsClick = async () => {
  //   let hash = encodeURIComponent(searchParams.get("hash"));
  //   try {
  //     const res = await onecodeAPI.post(`/public/customer/verifyApi?`, {
  //       hash: hash,
  //       partnerId: partnerDetails?.id,
  //     });
  //     if (res.data?.data?.url) {
  //       window.open(res.data?.data?.url, "_blank");
  //     }
  //   } catch (error) {
  //     console.log(error, "error---");
  //   }
  // };

  const checkLMSRecommendation = async () => {
    let hash = encodeURIComponent(searchParams.get("hash"));
    let recommendedBrands = [];
    setDataLoading(true);
    try {
      const res = await onecodeAPI.post(
        `/public/customer/lms/recommendations`,
        {
          hash: hash,
          partnerId: partnerDetails?.id,
        }
      );
      // recommendedBrands = _.get(res, `data.${locale}`, []);
      const eligibleBrands = _.get(res, `data.eligibleBrands`, []);
      const notEligiblePartners = _.get(res, `data.notEligiblePartners`, []);

      const notEligibleReasons = _.get(res, `data.message`, []);

      const partnerStatus = _.get(res, `data.partnerStatus`, []);
      const leadAddedBrands = _.map(partnerStatus, "partnerId");
      setBrandNotEligibleReasons(notEligibleReasons || []);
      let resStatus = _.get(res, "status", "");
      if (resStatus == 200) {
        let internalStatus = _.get(res, "data.status", null);
        setLmsInternalStatus(internalStatus);
        if (
          internalStatus == 2019 ||
          internalStatus == 2020 ||
          internalStatus == 2022
        ) {
          setDataLoading(true);
        }
        // else if (internalStatus == 2028) {
        //   onLMSBrandsClick();
        // }
        else if (internalStatus == 2027) {
          setEmailHandlePopup(true);
          setDataLoading(false);
        } else {
          setDataLoading(false);
          clearInterval(lmsRefreshIntervalId);
          const isEligibleBrand = eligibleBrands?.includes(
            Number(partnerDetails?.id)
          );
          if (
            isEligibleBrand ||
            leadAddedBrands?.includes(partnerDetails?.id)
          ) {
            applyToPartner();
          } else {
            setIsEligibleModalVisible(true);
            // setBrandNotEligiblePopup(true);
          }
        }

        // setRecommendations(rec);

        // setDataLoading(false);
      }
    } catch (error) {
      console.log(error);
      setDataLoading(false);
      clearInterval(lmsRefreshIntervalId);
      // const errMsg = _.get(
      //   error,
      //   "response.data.message",
      //   "Failed to get recommendations"
      // );
      // const errStatus = _.get(
      //   error,
      //   "response.data.status",
      //   "Failed to get recommendations"
      // );
      // if (errStatus == 500) {
      //   Toaster.error("Error", errMsg);
      // }
    }
  };

  const applyToPartner = async () => {
    let response;
    let hash = encodeURIComponent(searchParams.get("hash"));
    // console.log("partnerDetails", partnerDetails);
    let partnerId = partnerDetails?.id;

    if (partnerDetails?.shareContent?.getLink) {
      setLoading(true);
      let res = await onecodeAPI.post("/public/loanwiser/shareLink", {
        hash,
        partnerId,
      });

      let l = _.get(res, "data");
      let v = l + "&req_id=%7Bclick_id%7D";
      setLoading(false);
      // window.open(v, "_blank");
      setIsModalVisible(true);
      setPartnerLink(v);
    }else if(partnerDetails?.isExternalLeadCapture){
      let link=partnerDetails?.itemUrl
      const newLink= _.replace(link,"{{ONECODE}}",oneCode)  
      // window.open(newLink, "_blank")
      setIsModalVisible(true);
      setPartnerLink(newLink);
    } else if (partnerDetails?.leadFlow === "LF5") {
      try {
        setLoading(true);
        let resp = await onecodeAPI.post(`public/customer/generateLink?leadSource=${isCreditScoreCheck ? "scoreCheck" : ""}`, {
          hash,
          partnerId,
        });
        let statusCode = _.get(resp, "data.statusCode");
        let notEligibleReasons = _.get(resp, `data.message`, []);
        let dataIssue = _.get(resp, "data.message", "");
        let editLink = _.get(resp, "data.url", "");
        if (statusCode == 3307) {
          if (resp.data?.url) {
            window.open(resp?.data?.url);
          }
        } else if (statusCode == 3308) {

          setHandelContentModal(true);
          setResponsePopContent({
            heading: "Invalid data",
            description: dataIssue ? dataIssue : "",
            link:editLink
          });
        } else if (statusCode == 3309) {
          setBrandNotEligibleReasons(notEligibleReasons || []);
          setIsEligibleModalVisible(true);
        } else if (statusCode == 3310) {
          setHandelContentModal(true);
          setResponsePopContent({
            heading: "Issue",
            description: dataIssue ? dataIssue : "",
            link:""
          });
        }
        else if (resp?.data?.url) {
          // window.open("whatsapp://send?text=Heyy");
           setIsModalVisible(true);
           setPartnerLink(resp?.data?.url);
          //  setIsModalVisible(true);
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        if (error?.response?.status == 409) {
          setResponseStatus(error?.response?.status);
          setIsModalVisible(true);
        }
      }
    } else {
      try {
        setLoading(true);
        response = await onecodeAPI.post(`/public/getShareLink`, {
          hash,
          partnerId,
        });
        setLoading(false);
        // window.open(response.data, "_blank");
        setPartnerLink(response.data);
        setIsModalVisible(true);
      } catch (error) {
        setLoading(false);
        console.log(error);
      }
    }
  };

  const whatsAppMessageTemplate = `${
    customer?.fullName
  },%0ayou can simply start your application process for ${
    partnerDetails?.title
  } by clicking the link down here.%0a${encodeURIComponent(
    lf5Url
  )}%0aNote: This is a self generated link. Do not share it with anyone.`;

  return (
    <div className="newBrandCard">
      <div style={{ display: "flex" }}>
        <div className="brandLogo">
          <img
            alt=""
            src={`https://onecode-asset.s3.ap-south-1.amazonaws.com/Brand_Logo_PNGs/${partnerDetails?.id}.png`}
            // src={partnerDetails.logoUrl}
            style={{ width: "70px", height: "75%" }}
          />
        </div>
        <div className="brandDetails">
          <div className="brandNameAndIcon">
            <div className="brandName">
              <p style={{ fontWeight: "600", marginRight: "5px" }}>
                {partnerDetails?.title.length > 11
                  ? partnerDetails?.title.substr(0, 13) + ".."
                  : partnerDetails?.title}
              </p>
            </div>
            {/* <div className="brandIcon">
            <img
              alt=""
              src={brandIcon}
              style={{ width: "9px", marginTop: "-2px" }}
            />
          </div> */}
          </div>
          <div className="brandEarning">
            <p>
              {partnerDetails.shortDescription.length > 90
                ? partnerDetails.shortDescription.substr(0, 50) + ".."
                : partnerDetails.shortDescription}{" "}
            </p>
          </div>
        </div>
      </div>
      <div>
        {(categoryId == 9 || categoryId == 11 || categoryId == 10) && (
          <LoanCardMidSection partnerDetails={partnerDetails} />
        )}
        {(categoryId == 9 || categoryId == 11 || categoryId == 10) && (
          <div
            style={{
              marginTop: 10,
              marginBottom: 10,
              height: 1,
              backgroundColor: "#C7C9CA",
            }}
          />
        )}
        <div
          className="detailsAndApplyBtn"
          style={{ justifyContent: categoryId == 9 || categoryId == 11 || categoryId == 10 || partnerDetails?.partnerPdf ? "flex-end" : "center" }}
        >
          
          {(categoryId == 9 || categoryId == 11 || categoryId == 10) ? (
            <button
              onClick={() => {
                showLoanCardModal();
              }}
              style={{
                width: "85px",
                display: "flex",
                padding: "0px 10px",
                height: "100%",
                fontWeight: "500",
                color: "#747474",
                fontSize: "14px",
                backgroundColor: "#ffffff",
                // marginRight: "10px",
                marginRight: "10px",
                borderRadius: "5px",
                paddingTop: "3px",
                alignItems: "center",
                border: "1px solid #6C63FF",
                color: "#6C63FF",
              }}
            >
              <img
                alt=""
                src={info}
                style={{
                  width: "14px",
                  marginTop: "0px",
                  marginRight: "4px",
                }}
              />
              {t("recommendation.details")}
            </button>
          ) : (
            <></>
          )}
          { (categoryId != 9 && categoryId != 11 && categoryId != 10) && partnerDetails?.partnerPdf && (
            <button
              onClick={() => {
                openDetailFile();
                window?.Moengage?.track_event(
                  "add-customer_customer_brand_details_click",
                  {
                    customer_name: customer?.fullName,
                    customer_phonenumber: customer?.phoneNumber,
                    brand_name: partnerDetails?.title,
                    brand_category: partnerDetails?.subCategory,
                    // "category-level-brand_name":"",
                  }
                );
              }}
              style={{
                width: "85px",
                display: "flex",
                padding: "0px 10px",
                height: "100%",
                fontWeight: "500",
                color: "#747474",
                fontSize: "14px",
                backgroundColor: "#ffffff",
                // marginRight: "10px",
                marginRight: "10px",
                borderRadius: "5px",
                paddingTop: "3px",
                alignItems: "center",
                border: "1px solid #6C63FF",
                color: "#6C63FF",
              }}
            >
              <img
                alt=""
                src={info}
                style={{
                  width: "14px",
                  marginTop: "0px",
                  marginRight: "4px",
                }}
              />
              {t("recommendation.details")}
            </button>
          ) }
          <button
            onClick={() => {
              // if (
              //   customerDetails?.employmentType == "Not Working" &&
              //   (!customerDetails?.email ||
              //     !customerDetails?.dob ||
              //     !customerDetails?.gender) &&
              //   partnerDetails.isLMSFlow
              // ) {
              //   onLMSBrandsClick();
              // } else if (
              //   (!customerDetails?.email ||
              //     !customerDetails?.employerName ||
              //     !customerDetails?.workExperience ||
              //     !customerDetails?.dob ||
              //     !customerDetails?.gender) &&
              //   partnerDetails.isLMSFlow
              // ) {
              //   onLMSBrandsClick();
              // } else if (partnerDetails.isLMSFlow) {
              //   checkLMSRecommendation();
              // } else {
              //   applyToPartner();
              // }
              applyToPartner();
              // showModal();
              window?.Moengage?.track_event("add-customer_customer_apply", {
                customer_name: customer?.fullName,
                customer_phonenumber: customer?.phoneNumber,
                brand_name: partnerDetails?.title,
                brand_category: partnerDetails?.subCategory,
              });
            }}
            style={{
              width: "77px",
              //   height: "120%",
              fontWeight: "500",
              backgroundColor: "#6C63FF",
              border: "none",
              fontSize: "14px",
              borderRadius: "5px",
              color: "#FFFFFF",
              paddingTop: "-1px",
              marginRight: "10px",
            }}
          >
            {t("addcustomertotalinformation.Apply")}
            {loading && (
              <LoadingOutlined size={"small"} style={{ marginLeft: 10 }} />
            )}
          </button>

          {/* <button
            onClick={() => {
              
              if ( customerDetails?.employmentType == "Not Working" &&
                (!customerDetails?.email ||
                  !customerDetails?.dob || !customerDetails?.gender
                  ) &&
                partnerDetails.isLMSFlow
              ) {
                onLMSBrandsClick();
              } else if (
                (!customerDetails?.email ||
                  !customerDetails?.employerName ||
                  !customerDetails?.workExperience || !customerDetails?.dob || !customerDetails?.gender) &&
                partnerDetails.isLMSFlow
              ) {
                onLMSBrandsClick();
              } else if (partnerDetails.isLMSFlow) {
                checkLMSRecommendation();
              } else {
                applyToPartner();
              }
              // showModal();
              window?.Moengage?.track_event("add-customer_customer_apply", {
                customer_name: customer?.fullName,
                customer_phonenumber: customer?.phoneNumber,
                brand_name: partnerDetails?.title,
                brand_category: partnerDetails?.subCategory,
              });
            }}
            style={{
              width: "77px",
              //   height: "120%",
              fontWeight: "500",
              backgroundColor: "#6C63FF",
              border: "none",
              fontSize: "14px",
              borderRadius: "5px",
              color: "#FFFFFF",
              paddingTop: "-1px",
              marginLeft: "10px",
              // marginLeft: partnerDetails?.partnerPdf ? "10px" : "0px",
            }}
          >
            {t("addcustomertotalinformation.Apply")}
            {dataLoading && (
              <LoadingOutlined size={"small"} style={{ marginLeft: 10 }} />
            )}
          </button> */}
        </div>
        {/* <Modal
          visible={isModalVisible}
          onCancel={handleCancel}
          maskStyle={{
            background: "rgba(0,0,0,0.7)",
          }}
          footer={null}
          centered={true}
          closable={true}
          bodyStyle={{
            border: "1px solid  #fff",
            justifySelf: "center",
            borderRadius: "10px",
            padding: "20px",
          }}
          width="90%"
        >
    
          <p
            style={{ textAlign: "center", fontSize: "15px", color: "#7D7D7D" }}
          >
            {responseStatus == 409 ? (
              `Already applied for ${partnerDetails?.title}`
            ) : (
              <>
                {" "}
                <p
                  style={{
                    marginBottom: "7px",
                    marginTop: "15px",
                    fontWeight: "700",
                    fontSize: "1.2rem",
                  }}
                >
                  You are eligible to apply ✅
                </p>{" "}
                <p style={{ textAlign: "center", lineHeight: "17px" }}>
                  Link sent on +91{customer?.phoneNumber} via Whatsapp{" "}
                  <RiWhatsappFill
                    style={{
                      position: "relative",
                      color: "#25D366",
                      fontSize: "20px",
                      top: 2,
                    }}
                  />
                  . Please check your whatsapp to start your application.
                </p>
                <p style={{ textAlign: "center", margin: 0 }}>
                  {" "}
                  Didn't receive it? Share link with yourself on SMS
                </p>
                <a
                  onClick={checkNavigation}
                  href={`sms:+91${customer?.phoneNumber}?body=${whatsAppMessageTemplate}`}
                  style={{
                    background: "#6C63FF",
                    borderRadius: "5px",
                    width: "fit-content",
                    textAlign: "center",

                    border: "none",
                    padding: "0.5rem",
                    paddingLeft: "0.9rem",
                    paddingRight: "0.9rem",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "10px auto",
                  }}
                >
                  <MdSms
                    style={{
                      color: "white",
                      marginRight: "5px",
                    }}
                  />
                  Generate Link
                </a>
              </>
            )}
          </p>
        </Modal> */}
        <ApplyModal
          isModalVisible={isModalVisible}
          handleCancel={handleCancel}
          responseStatus={responseStatus}
          partnerDetails={partnerDetails}
          setIsModalVisible={setIsModalVisible}
          customer={customerDetails}
          link={lf5Url}	
          buttonToDisplay={partnerDetails?.attributionType == "WEB" ? "continue" : "whatsapp"}	
          partnerLink={partnerLink}
        />
        {/* <Modal
          visible={isModalVisible}
          onCancel={handleCancel}
          footer={null}
          centered={true}
          closable={true}
          bodyStyle={{
            border: "1px solid  #fff",
            justifySelf: "center",
            borderRadius: "10px",
            padding: "20px",
          }}
          width="90%"
          closeIcon={<CloseOutlined className="modalCloseBtn" />}
        >
          <p
            style={{
              textAlign: "center",
              fontSize: "15px",
              color: "#7D7D7D",
            }}
          >
            {responseStatus == 409 ? (
              <DynamicTextFormatter
                textString={t("recommendation.AlreadyApplied")}
                values={{
                  __PartnerTitle__: { value: partnerDetails?.title },
                }}
              />
            ) : (
              <>
                <p></p>
              </>
            )}
          </p>

          {responseStatus !== 409 && (
            <div
              style={{
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <button
                onClick={() => {
                  if (responseStatus == 409) {
                    setIsModalVisible(false);
                  } else {
                    window.open(
                      `whatsapp://send?text=${whatsAppMessageTemplate}&phone=+91${customer?.phoneNumber}`
                    );
                  }
                }}
                style={{
                  background: "#00c34e",
                  borderRadius: "5px",
                  textAlign: "center",
                  justifyContent: "center",
                  border: "none",
                  padding: "0.5rem",
                  paddingLeft: "0.9rem",
                  paddingRight: "0.9rem",
                }}
              >
                <p
                  style={{
                    color: "#6C63FF",
                    fontSize: "15px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: 0,
                    padding: 0,
                  }}
                >
                  {responseStatus == 409 ? (
                    "Ok"
                  ) : (
                    <>
                      <RiWhatsappFill
                        style={{
                          color: "#FFF",
                          // color: "#25D366",
                          fontSize: "15px",
                        }}
                      />
                      <p
                        style={{
                          color: "#FFF",
                          fontSize: "15px",
                          display: "flex",
                          alignItems: "flex-start",
                          justifyContent: "center",
                          marginBottom: 0,
                          padding: 0,
                          marginLeft: "5px",
                        }}
                      >
                        Generate Link
                      </p>
                    </>
                  )}
                </p>
              </button>
            </div>
          )}
        </Modal> */}

        {isEligibleModalVisible && (
          <Modal
            visible={isEligibleModalVisible}
            onCancel={handleEligiblePopupCancel}
            footer={null}
            centered={true}
            closable={true}
            bodyStyle={{
              border: "1px solid  #fff",
              justifySelf: "center",
              borderRadius: "10px",
              padding: "20px",
            }}
            width="90%"
            closeIcon={<CloseOutlined className="modalCloseBtn" />}
          >
            <p
              style={{
                textAlign: "center",
                fontSize: "15px",
                color: "#7D7D7D",
                fontWeight: "bold",
              }}
            >
              Not Eligible
            </p>
            {  brandNotEligibleReasons?.length > 0 && brandNotEligibleReasons?.map((item, key) => (
              <p
                style={{
                  textAlign: "center",
                  fontSize: "15px",
                  color: "#7D7D7D",
                }}
              >
                {key + 1}. {item}
              </p>
            ))}
          </Modal>
        )}
        {loanCardModalVisible && (
          <LoanCardModal
            isModalVisible={loanCardModalVisible}
            setIsModalVisible={setIsModalVisible}
            handleCancel={handleLoanCardCancel}
            partnerDetails={partnerDetails}
            customer={customer}
            customerDetails={customerDetails}
          />
        )}
        {handelContentModal && (
          <ContentModal
            modalVisible={handelContentModal}
            popupContent={responsePopContent}
            setHandelContentModal={setHandelContentModal}
            // popupContent={"suupppp"}
          />
        )}
        {emailHandlePopup && (
          <Modal
            visible={emailHandlePopup}
            onCancel={hideEmailHandlePopup}
            footer={null}
            centered={true}
            closable={true}
            bodyStyle={{
              border: "1px solid  #fff",
              justifySelf: "center",
              borderRadius: "10px",
              padding: "20px",
            }}
            width="90%"
            closeIcon={<CloseOutlined className="modalCloseBtn" />}
          >
            <p
              style={{
                textAlign: "center",
                fontSize: "15px",
                color: "#7D7D7D",
                fontWeight: "bold",
              }}
            >
              Invalid Email ID!
            </p>

            <p
              style={{
                textAlign: "center",
                fontSize: "15px",
                color: "#7D7D7D",
              }}
            >
              Email already exists OR invalid characters/length/domain in Email,
              please ask your Business Consultant to update the email ID and
              apply again.
            </p>
            <div style={{ textAlign: "center" }}>
              <button
                onClick={() => {
                  hideEmailHandlePopup();
                }}
                style={{
                  width: "90%",
                  fontWeight: "500",
                  backgroundColor: "#6C63FF",
                  border: "none",
                  fontSize: "14px",
                  borderRadius: "5px",
                  color: "#FFFFFF",
                  padding: "5px",
                }}
              >
                Ok, got it.
              </button>
            </div>
          </Modal>
        )}
      </div>
    </div>
  );
}